module.exports = __webpack_public_path__ + "static/media/privacypolicy.34d9396a.htm";